/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Document_LabelInputs */

const cs_templates_ai_document_label = /** @type {(inputs: Templates_Ai_Document_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import PDF / DOCX`)
};

const en_templates_ai_document_label = /** @type {(inputs: Templates_Ai_Document_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import PDF / DOCX`)
};

/**
* | output |
* | --- |
* | "Import PDF / DOCX" |
*
* @param {Templates_Ai_Document_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_document_label = /** @type {((inputs?: Templates_Ai_Document_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Document_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_document_label(inputs)
	return cs_templates_ai_document_label(inputs)
});